import { render, staticRenderFns } from "./PersonAddressDetails.vue?vue&type=template&id=f0195e84&"
import script from "./PersonAddressDetails.vue?vue&type=script&lang=js&"
export * from "./PersonAddressDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports